import { Component } from 'react';
import ReactTable from 'react-table';
import type { TableProps } from 'react-table';

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface SelectableReactTableProps<D> extends TableProps {
  onSelect(elt: D): void;
  selectedElement?: D;
  // used to determine if a particular row in the table is the selected row. Its possible to get equivalent objects that reference different memory addresses
  // if not present, then reference comparison is used
  areEqual?: (a: D, b: D) => boolean;
  selectedBackgroundColor: string;
  selectedTextColor: string;
  selectedData: D;
}

class SelectableReactTable<D> extends Component<SelectableReactTableProps<D>> {
  renderDataRow = (_state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      const onClick = () => {
        this.props.onSelect(rowInfo.original);
      };

      if (this.props.selectedData &&
        // Check references first, if they're equal we're sure that the two elements are the same
        ((this.props.selectedData === rowInfo.original) ||
        (this.props.areEqual && this.props.areEqual(this.props.selectedData, rowInfo.original)))) {
        return {
          onClick,
          style: {
            background: this.props.selectedBackgroundColor,
            color: this.props.selectedTextColor,
          },
        };
      }

      return { onClick };
    }

    return {};
  };

  render() {
    const props = { ...this.props, getTrProps: this.renderDataRow };
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <ReactTable {...props} />;
  }
}

export default SelectableReactTable;
